import { render, staticRenderFns } from "./updateSkag.vue?vue&type=template&id=03e8ffe1"
import script from "./updateSkag.vue?vue&type=script&lang=js"
export * from "./updateSkag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports